export default __webpack_public_path__ + "static/media/logo-transparent.0c013cc1.svg";